import config from './config/index'
import Communicator from './shared/decorators/communicator/Communicator'
import _debug from 'debug'

const debug = _debug('geneva:COMMUNICATOR')

export default class CommunicatorSingleton {
  // instance: Communicator

  static getInstance() {
    if (!this.instance) {
      this.instance = new Communicator(config.ws)
      this.instance.addLogger((data, dir) => {
        debug(`${dir === 'out' ? '<--' : '-->'} ${(data.action || '').toUpperCase()}`, data)
      })
    }
    return this.instance
  }
}
